import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { AppRoutingModule } from '@src/app/app-routing.module';
import { AppComponent } from '@src/app/app.component';
import { ListModule } from '@src/app/list/list.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
// import { HttpConfigInterceptor} from '@src/app/helpers/httpconfig.interceptor';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

//Material Angular Components
import {MatTableModule} from '@angular/material/table';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatStepperModule } from '@angular/material/stepper';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatDialogModule} from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import {MatTooltipModule} from '@angular/material/tooltip';
import { MatTabsModule } from '@angular/material/tabs'; 
//Ngx-Bootstrap Components
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { ModalModule } from 'ngx-bootstrap/modal';

//Components
import { WizardComponent, AlertComponent } from '@src/app/wizard/wizard.component';
// import { ModalComponent } from '@src/app/components/modal/modal.component';

import { NgxMaskModule, IConfig } from 'ngx-mask'

//Services
import { AppService } from '@src/app/services/app.service';
import { AuthService } from '@src/app/services/auth.service';
import { FilterPipe } from '@src/app/pipes/filter.pipe';
import { SavedCardsComponent } from '@src/app/wizard/saved-cards.component';
import { AppointmentCancelDialogComponent } from '@src/app/wizard/appointment-cancel-dialog';
import { PaymentPageDialogComponent } from '@src/app/wizard/payment-page-dialog';
import { ThankYouComponent } from '@src/app/wizard/thank-you.component';
import { DialogPopUpComponent } from '@src/app/dialog-pop-up/dialog-pop-up.component';
import { AgreementComponent } from '@src/app/agreement/agreement.component';
import { TableComponent } from '@src/app/table/table.component';
import { PopupComponent } from '@src/app/popup/popup.component';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { CardOnFileComponent } from '@src/app/card-on-file/card-on-file.component';
import { AddImmunizationComponent } from '@src/app/add-immunization/add-immunization.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CardAddComponent } from '@src/app/card-add/card-add.component';
import {GooglePlacesAPI} from '@src/app/services/googlePlaces.service';
import { AddVetComponent } from '@src/app/add-vet/add-vet.component';
import { MatCarouselModule } from 'ng-mat-carousel';
import { ImagesAndVideosComponent } from '@src/app/images-and-videos/images-and-videos.component';
import { MAT_DATE_FORMATS ,DateAdapter } from '@angular/material/core';
import { RecaptchaModule } from 'ng-recaptcha';

import { SentryErrorHandler } from '@src/app/services/sentry.service';
import { BreedSelectorDialogComponent } from '@src/app/breed-selector-dialog/breed-selector-dialog.component';
import { SocialLoginComponent } from '@src/app/social-login/social-login.component';

export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;
import { NgOtpInputModule } from 'ng-otp-input';
import { UserUpdateDialogComponent } from '@src/app/wizard/user-update-dialog/user-update-dialog.component';

@NgModule({
  declarations: [
    AppComponent,
    AppComponent,
    WizardComponent,
    // ModalComponent,
    ThankYouComponent,
    AlertComponent,
    FilterPipe,
    SavedCardsComponent,
    AppointmentCancelDialogComponent,
    PaymentPageDialogComponent,
    DialogPopUpComponent,
    AgreementComponent,
    TableComponent,
    PopupComponent,
    CardOnFileComponent,
    AddImmunizationComponent,
    CardAddComponent,
    AddVetComponent,
    ImagesAndVideosComponent,
    BreedSelectorDialogComponent,
    SocialLoginComponent,
    UserUpdateDialogComponent  
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    NgbModule,
    ListModule,
    FormsModule,
    ReactiveFormsModule,
    MatStepperModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonToggleModule,
    MatExpansionModule,
    MatProgressBarModule,
    MatIconModule,
    MatTableModule,
    MatButtonModule,
    MatListModule,
    MatOptionModule,
    MatRadioModule,
    MatCheckboxModule,
    MatCardModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDialogModule,
    MatTabsModule,
    MatAutocompleteModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    BsDatepickerModule.forRoot(),
    ButtonsModule.forRoot(),
    ModalModule.forRoot(),
    NgxMaskModule.forRoot(),  
    MatCarouselModule.forRoot(),
    RecaptchaModule,
    NgOtpInputModule
  ],
  providers: [
    AppService,
    AuthService,
    GooglePlacesAPI,
    // { provide: HTTP_INTERCEPTORS, useClass: HttpConfigInterceptor, multi: true }
    {provide: LocationStrategy, useClass: HashLocationStrategy},
    { provide: ErrorHandler, useClass: SentryErrorHandler },
    { provide: MAT_DATE_FORMATS, useValue: {
      display: {
        dateInput: 'input',  
        monthYearLabel: 'MMM YYYY', 
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
      }
    }},
  ],
  entryComponents: [
    AlertComponent,
    SavedCardsComponent,
    AppointmentCancelDialogComponent,
    PaymentPageDialogComponent,
    DialogPopUpComponent,
    AgreementComponent,
    PopupComponent,
    CardOnFileComponent,
    AddImmunizationComponent,
    AddVetComponent,
    BreedSelectorDialogComponent,
    ImagesAndVideosComponent,
    SocialLoginComponent,
    UserUpdateDialogComponent
  ],
  schemas: [NO_ERRORS_SCHEMA],
  bootstrap: [AppComponent],
})
export class AppModule { 
  
}
